/**
 * Configuração de Providers com Suporte a Presença (typing/recording)
 * 
 * Define quais providers têm implementação de eventos de presença.
 * A Meta Cloud API NÃO suporta presença — limitação da plataforma.
 * 
 * Providers implementados:
 * - z-api: Eventos automáticos via webhook
 * - waha: Requer inscrição explícita via provider-proxy subscribe_presence
 * 
 * Providers SEM suporte:
 * - meta-whatsapp: API não oferece eventos de presença
 */

/**
 * Lista de slugs de providers que suportam eventos de presença
 * Manter sincronizado com os cases implementados na Edge Function provider-proxy
 */
export const PRESENCE_SUPPORTED_PROVIDERS = [] as const;

/**
 * Tipo para providers com suporte a presença (inferido do array)
 */
export type PresenceSupportedProvider = typeof PRESENCE_SUPPORTED_PROVIDERS[number];

/**
 * Verifica se um provider suporta eventos de presença (typing/recording)
 * 
 * @param providerSlug - Slug do provider (ex: 'waha', 'z-api', 'meta-whatsapp')
 * @returns true se o provider suporta presença
 * 
 * @example
 * if (isPresenceSupported(conversation.inbox.provider_slug)) {
 *   subscribePresence(inboxId, phone);
 * }
 */
export const isPresenceSupported = (providerSlug: string | null | undefined): boolean => {
  if (!providerSlug) return false;
  return PRESENCE_SUPPORTED_PROVIDERS.includes(providerSlug as PresenceSupportedProvider);
};
